import { API_URL } from "config";
import Http from "util/https";
import { Order, OrderGeneralSixBill, OrderSixBill, OrderTyreSixBill, ProductCdSearchParam, ProductCompletionGeneralResponseApi, ProductCompletionResponseApi, ProductCompletionTyreResponseApi, ProductSearchInfo, ProductSearchResponseApi, RequiredOneInSpecifiedKeys } from "../types";

type Arg =
// RequiredOneInSpecifiedKeys<
{
  item_cd?: string;
  jan_cd?: string;
  client_cd?: string;
}
// , 'item_cd' | 'jan_cd'>;

/**
 * 商品コード補完Api
 * @param params 補完条件パラメータ
 * @param isTyre タイヤ・ホイールの補完かどうか
 * @param index idを決めるための何番目の要素か
 * @returns ProductSearchInfo
 */
export default async function getProductCompletionApi(params: Arg, isTyre: boolean, index: number): Promise<OrderSixBill | undefined> {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/order/item/info`;
  const res = await http.post<ProductCompletionResponseApi>(url, params);
  console.log(res);

  // const res: {data: ProductCompletionResponseApi} = {data: isTyre
  //   ? {
  //     item_cd: params.item_cd ?? '012345',
  //     jan_cd: params.jan_cd ?? '0123456789012',
  //     unit_cost_price: 1000,
  //     unit_sale_price: 1200,
  //     class_name: '02 タイヤ',
  //     brand: 'ブランド1',
  //     item_name: '商品1',
  //     size: '',
  //     store_quantity: 2000,
  //     depot_quantity: {
  //       meiwa: 1000,
  //       kasai: 1100,
  //       tohoku: 1200,
  //       itochu: 1300,
  //       showa: 1400,
  //     },
  //     vendor_nearby_quantity: 60000,
  //     vendor_centor_quantity: 10000000,
  //     vendor_selector: [{
  //       vendor_cd: "000001",
  //       vendor_name: "ﾌﾞﾘﾁﾞｽﾄﾝ"
  //     },{
  //       vendor_cd: "000002",
  //       vendor_name: "ﾕﾋﾟﾃﾙ"
  //     },]
  //   } : {
  //     item_cd: params.item_cd ?? '012345',
  //     jan_cd: params.jan_cd ?? '0123456789012',
  //     unit_cost_price: 1000,
  //     unit_sale_price: 1200,
  //     class_name: '02 タイヤ',
  //     brand: 'ブランド1',
  //     item_name: '商品1',
  //     size: '',
  //     store_quantity: 2000,
  //     depot_quantity: 30000,
  //     vendor_nearby_quantity: 60000,
  //     vendor_centor_quantity: 10000000,
  //     vendor_selector: [{
  //       vendor_cd: "000001",
  //       vendor_name: "ﾌﾞﾘﾁﾞｽﾄﾝ"
  //     },{
  //       vendor_cd: "000002",
  //       vendor_name: "ﾕﾋﾟﾃﾙ"
  //     },]
  //   }
  // };
  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});


  // 商品コードやJANコードに一致するデータがない場合、undefinedを返す
  if (!res.data) return undefined;

  let productCompletion: OrderSixBill;
  if (isTyre) {
    const comp = res.data as ProductCompletionTyreResponseApi;
    productCompletion = {
      id: index + 1,
      productCd: comp.item_cd ?? '',
      classification: comp.class_name ?? '',
      supplierName: "",
      brand: comp.brand ?? '',
      productName: comp.item_name ?? '',
      size: comp.size ?? '',
      orderCount: 0,
      isSet: false,
      isStaggered: false,
      janCd: comp.jan_cd ?? '',
      headquartersUnitCost: comp.unit_base_price || 0,
      wholesaleUnitPrice: comp.unit_cost_price || 0,
      shopUnitPrice: comp.unit_sale_price || 0,
      shopStock: comp.store_quantity || 0,
      headquartersStock: {
        meiwa: comp.quantity_meiwa || 0,
        kasai: comp.quantity_kasai || 0,
        tohoku: comp.quantity_tohoku || 0,
        itochu: comp.quantity_itochu || 0,
        showa: comp.quantity_shouwa || 0,
      },
      supplierStock: {
        center: comp.vendor_centor_quantity || 0,
        neighborhood: comp.vendor_nearby_quantity || 0,
      },
      shopRemarks: "",
      headquartersRemarks: "",
      supplierOptions: comp.vendor_selector.map((vs) => ({supplierCd: vs.vendor_cd ?? '', supplierName: vs.vendor_name ?? ''})),
      errors: {}
    } as OrderTyreSixBill;
  } else {
    const comp = res.data as ProductCompletionGeneralResponseApi;
    productCompletion = {
      id: index + 1,
      productCd: comp.item_cd ?? '',
      janCd: comp.jan_cd ?? '',
      classification: comp.class_name ?? '',
      supplierName: "",
      productName: comp.item_name ?? '',
      orderCount: 0,
      headquartersUnitCost: comp.unit_base_price || 0,
      wholesaleUnitPrice: comp.unit_cost_price || 0,
      shopUnitPrice: comp.unit_sale_price || 0,
      headquartersStock: comp.depot_quantity || 0,
      shopStock: comp.store_quantity || 0,
      supplierStock: {
        center: comp.vendor_centor_quantity || 0,
        neighborhood: comp.vendor_nearby_quantity || 0,
      },
      shopRemarks: "",
      headquartersRemarks: "",
      supplierOptions: comp.vendor_selector.map((vs) => ({supplierCd: vs.vendor_cd ?? '', supplierName: vs.vendor_name ?? ''})),
      errors: {}
    } as OrderGeneralSixBill;
  }

  return productCompletion;
}